export { default } from './Carousel';
export type { Props, Props as CarouselSupportBlockProps } from './Carousel';
